$(".closeCookieNo").on("click", function() {
    $(this)
        .closest(".cookies")
        .hide();
    Cookies.set("cookie", 2);
});

$(".closeCookie").on("click", function() {
    $(this)
        .closest(".cookies")
        .hide();
    Cookies.set("cookie", 1, {
        expires: 365
    });
});

// superpanelowa
require("./superpanelowa");

// RegistyChanges
// $(".reqistryChangesBtn").on("click", function() {
//     if (
//         $(this)
//             .closest(".reqistryChangesWrap")
//             .find(".reqistryChangesInner")
//             .is(":visible")
//     ) {
//         $(this)
//             .closest(".reqistryChangesWrap")
//             .find(".reqistryChangesInner")
//             .slideUp();
//         $(this)
//             .find(".reqistryChangesBtnShow")
//             .show();
//         $(this)
//             .find(".reqistryChangesBtnClose")
//             .hide();
//     } else {
//         $(this)
//             .closest(".reqistryChangesWrap")
//             .find(".reqistryChangesInner")
//             .slideDown();
//         $(this)
//             .find(".reqistryChangesBtnShow")
//             .hide();
//         $(this)
//             .find(".reqistryChangesBtnClose")
//             .show();
//     }
// });

// Popup
if ($(".popup").length > 0) {
    setTimeout(function() {
        var popup = $(".popup--hidden");
        $(popup).removeClass("popup--hidden");
        $(popup).addClass("show");
    }, 600);

    $("#popupClose").on("click", function() {
        var popup = $(".popup");
        $(popup).removeClass("show");
        $(popup).addClass("hide");
    });
}

// Alerts
setTimeout(function() {
    $(".alerts-floating")
        .find(".alert")
        .fadeOut();
}, 5000);

$(document).on("click", ".alertClose", function() {
    $(this)
        .closest(".alert")
        .fadeOut();
});

// jQuery.event.special.touchstart = {
//     setup: function( _, ns, handle ){
//         this.addEventListener("touchstart", handle, { once: true, passive: true });
//     }
// };

// $(".linkDropdown")
//     .on("mouseenter", function() {
//         $(this).addClass("open");
//     })
//     .on("mouseleave", function() {
//         $(this).removeClass("open");
//     });

$(".sliderGalery").slick({
    rows: 0,
    adaptiveHeight: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: true,
    infinite: true,
    swipeToSlide: true,
    arrows: true,
    dots: false,
    mobileFirst: true,
    nextArrow:
        '<button type="button" class="slick-prev"><span class="sr-only">Następny slajd</span><svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="50.124mm" height="85.008mm" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" viewBox="0 0 50.124 85.008" xmlns:xlink="http://www.w3.org/1999/xlink"> <g> <polygon class="initial" points="-0,42.5038 42.5083,85.0081 50.124,77.3927 15.055,42.5038 49.9469,7.6149 42.3312,-0.0002"/></g></svg></button>',
    prevArrow:
        '<button type="button" class="slick-next"><span class="sr-only">Poprzedni slajd</span> <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" viewBox="0 0 50.124 85.008" xmlns:xlink="http://www.w3.org/1999/xlink"> <g> <polygon class="initial" points="50.1242,42.5038 7.6156,85.0081 -0.0002,77.3927 35.069,42.5038 0.1769,7.6149 7.7927,-0.0002 "/> </g></svg></button>',
    arrows: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 1280,
            settings: {
                slidesToShow: 3
            }
        }
    ]
});

$(".sliderMain").slick({
    rows: 0,
    arrows: false,
    swipeToSlide: true,
    slidesToShow: 1,
    draggable: true,
    swipeToSlide: true,
    focusOnSelect: true,
    infinite: false
});

document.addEventListener("DOMContentLoaded", function() {
    const header = document.querySelector(".header");
    const mainSlider = document.querySelector("#first-section");
    if (header && mainSlider) {
        const observer = new IntersectionObserver(
            function(entries) {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        header.classList.add("bg");
                    } else {
                        header.classList.remove("bg");
                    }
                });
            },
            {
                threshold: 0.7
            }
        );

        observer.observe(mainSlider);

    } else {
        console.error("Nie można zainicjować IntersectionObserver, elementy header lub mainSlider nie istnieją.");
    }

    // Otwieranie menu
    let rwdMenuBtn = document.querySelector(".rwdMenuBtn");
    rwdMenuBtn.addEventListener("click", function() {
        let menuRwd = document.querySelector(".menu__rwd");
        menuRwd.classList.add("open");
        document.body.classList.add("menuOpened");
    });

    // Zamykanie menu
    let rwdMenuBtnClose = document.querySelector(".rwdMenuBtnClose");
    rwdMenuBtnClose.addEventListener("click", function() {
        let menuRwd = document.querySelector(".menu__rwd");
        menuRwd.classList.remove("open");
        document.body.classList.remove("menuOpened");
    });

    // Zamykanie menu klawiszem Escape
    document.addEventListener("keydown", function(e) {
        const key = e.key;
        if (key === "Escape" || key === "Esc" || key === "27") {
            let menuRwd = document.querySelector(".menu__rwd");
            menuRwd.classList.remove("open");
            document.body.classList.remove("menuOpened");
            let popup = document.querySelector("#popup");
            if (popup) {
                popup.classList.remove("show");
                popup.classList.add("hide");
            }
        }
    });

    // all sliders config in HP
    const sliderConfigs = {
        configAboutNumber: {
            rows: 0,
            nextArrow:
                '<button type="button" class="slick-next"><span class="sr-only">Nastepny slajd</span> <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="85.009mm" height="50.125mm" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" viewBox="0 0 85.009 50.125" xmlns:xlink="http://www.w3.org/1999/xlink"> <g> <polygon fill="#ffffff" class="initial" points="42.5047,50.1247 0.0003,7.6162 7.6156,0.0002 42.5047,35.0696 77.3937,0.1772 85.0088,7.7932 "/> </g> </svg> </button>',
            prevArrow:
                '<button type="button" class="slick-prev"><span class="sr-only">Poprzedni slajd</span> <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="85.009mm" height="50.125mm" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" viewBox="0 0 85.009 50.125" xmlns:xlink="http://www.w3.org/1999/xlink"> <g> <polygon fill="#ffffff" class="initial" points="42.5047,50.1247 0.0003,7.6162 7.6156,0.0002 42.5047,35.0696 77.3937,0.1772 85.0088,7.7932 "/> </g> </svg> </button>',
            infinite: false,
            arrows: true,
            dots: false,
            centerMode: false,
            centerPadding: "0",
            verticalSwiping: true,
            vertical: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        arrows: true,
                        slidesToShow: 2,
                        verticalSwiping: true,
                        vertical: true,
                        centerMode: false,
                        centerPadding: "0"
                    }
                }
            ]
        },
        configNews: {
            rows: 0,
            nextArrow:
                '<button type="button" class="slick-prev"><span class="sr-only">Następny slajd</span><svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="50.124mm" height="85.008mm" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" viewBox="0 0 50.124 85.008" xmlns:xlink="http://www.w3.org/1999/xlink"> <g> <polygon class="initial" points="-0,42.5038 42.5083,85.0081 50.124,77.3927 15.055,42.5038 49.9469,7.6149 42.3312,-0.0002"/></g></svg></button>',
            prevArrow:
                '<button type="button" class="slick-next"><span class="sr-only">Poprzedni slajd</span> <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" viewBox="0 0 50.124 85.008" xmlns:xlink="http://www.w3.org/1999/xlink"> <g> <polygon class="initial" points="50.1242,42.5038 7.6156,85.0081 -0.0002,77.3927 35.069,42.5038 0.1769,7.6149 7.7927,-0.0002 "/> </g></svg></button>',
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            dots: false,
            mobileFirst: true,
            draggable: true,
            swipeToSlide: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        }
    };

    initializeSliderWhenSectionVisible(".section--about", ".sliderAboutNumber", ".configAboutNumber");
    initializeSliderWhenSectionVisible(".section--news", ".sliderNews", ".configNews");

    function initializeSliderWhenSectionVisible(sectionSelector, sliderSelector, configClassName) {
        const sections = document.querySelectorAll(sectionSelector);

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const slidersWithinSection = entry.target.querySelectorAll(sliderSelector);

                    const sanitizedConfigClassName = configClassName.replace(".", ""); // remove the dot if present
                    const configToUse = sliderConfigs[sanitizedConfigClassName];

                    slidersWithinSection.forEach((slider) => {
                        if (!$(slider).hasClass("slick-initialized") && configToUse) {
                            $(slider).slick(configToUse);
                        }
                    });

                    observer.unobserve(entry.target);
                }
            });
        });

        sections.forEach((section) => {
            observer.observe(section);
        });
    }

    const boxElements = document.querySelectorAll(".box");

    boxElements.forEach(function(box) {
        box.addEventListener("mouseover", function() {
            const activeBox = document.querySelector(".box.box--active");
            if (activeBox) {
                activeBox.classList.remove("box--active");
            }
        });
        box.addEventListener("mouseout", function() {
            boxElements[0].classList.add("box--active");
        });
    });

    const animation = document.querySelectorAll(".animation-slide");

    const options = {
        threshold: 0.4
    };

    observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                return;
            }
            entry.target.classList.add("animated");
        });
    }, options);

    animation.forEach((image) => {
        observer.observe(image);
    });
});

$(".fancybox").fancybox({});
